import { PropertyManagementSystem } from "shared/types/partner";

export enum SyncOption {
  NEVER = "never",
  FIRST_SYNC = "first_time",
  EVERY_SYNC = "every"
}

export const SyncOptionLabels = {
  [SyncOption.NEVER]: "Never",
  [SyncOption.FIRST_SYNC]: "Only first sync",
  [SyncOption.EVERY_SYNC]: "Every sync"
};

export const PMSNames: Record<PropertyManagementSystem, string> = {
  [PropertyManagementSystem.Appfolio]: "Appfolio",
  [PropertyManagementSystem.Buildium]: "Buildium",
  [PropertyManagementSystem.RentManager]: "Rent Manager",
  [PropertyManagementSystem.Rentvine]: "Rentvine",
  [PropertyManagementSystem.Resman]: "Resman",
  [PropertyManagementSystem.RentersWarehouse]: "Renters Warehouse",
  [PropertyManagementSystem.ManageAmerica]: "ManageAmerica",
  [PropertyManagementSystem.Entrata]: "Entrata",
  [PropertyManagementSystem.Quext]: "Quext",
  [PropertyManagementSystem.Propertyware]: "Propertyware",
  [PropertyManagementSystem.Yardi]: "Yardi",
  [PropertyManagementSystem.Other]: "Other"
};

export enum IntegrationTab {
  General = "General",
  Credentials = "Credentials"
}

export enum ProspectsCreationOptions {
  Decision = "decision",
  Submission = "submission",
  Start = "start"
}
